<footer [style.backgroundColor]="'var(--pax-footer-background)'" class="h-[129px] px-6 xl:px-0 relative z-50">
    <div class="px-1 mx-auto max-w-7xl h-full">
        <div class="flex justify-between items-center h-full">
            <!-- Language Switcher -->
            <div class="text-sm">
                @for (language of availableLanguages(); track language; let last = $last) {
                    <span
                        [class.text-[var(--pax-footer-text-color-active)]="lang() === language"
                        [class.font-bold]="lang() === language"
                        class="text-[var(--pax-footer-text-color)] transition-colors cursor-pointer hover:text-[var(--pax-footer-text-color-hover)]"
                        (click)="languageChange.emit(language)"
                        >{{ language.toUpperCase() }}</span
                    >
                    @if (!last) {
                        <span class="mx-2 text-[var(--pax-footer-divider-color)]">|</span>
                    }
                }
            </div>

            <!-- Middle Links -->
            <div class="flex gap-8 text-sm">
                @for (item of footerItems(); track item.path) {
                    <a
                        [routerLink]="item.path"
                        [routerLinkActive]="['font-bold']"
                        class="text-[var(--pax-footer-text-color)] transition-colors hover:text-[var(--pax-footer-text-color-hover)]"
                        >{{ item.label }}</a
                    >
                }
            </div>

            <!-- Logo -->
            <div class="flex items-center">
                <img [src]="logoUrl()" alt="Logo" class="h-10" />
            </div>
        </div>
    </div>
</footer>
